import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';
import { func } from "@hapi/joi";
import { mode } from "crypto-js";

export default {
    saveOrder,
    editOrder,
    getMultiCropsByGroupID,
    GetCollectionTypeByOperationEntity,
    GetBuyerByOperationEntity,
    GetAllOrders,
    getSelectedOrderDetails,
    removeOrder,
    getNewOrders,
    getNewOrdersForDropDown,
    GetCollectionTypeByOrderID,
    GetSuppliersByOperationEntity,
    SaveSupplierOrder,
    getOrdersForSupplierVerify,
    saveApproveStatus,
    removeSelectedSupplierOrderItem,
    CompleteOrder,
    GetOrdersForWeighmentVerification,
    GetSupplierItemDetails,
    OrderConfirm,
    GetOrdersForCompletion,
    saveOrderCompletionStatus,
    rejectSelectedSupplierOrderItem,
    getRemainSupplierCount,
    GetImagesForWeighnItem,
    GetCollectionTypeByOperationEntityForSearchDropDown,
    getUsers,
    approveSelectedSupplierOrderItem,
    OrderItemComplete,
    CheckIsQuantityExceeded,
    saveOrderitem,
    getOrderDetailsForSupplierAddScreen,
    getOrderDetailsForApproveSupplierScreen,
    getOrderDetailsForWeighmentVerifyScreen,
    getOrderDetailsForOrderCompletionScreen,
    rejectAllSupplierItems,
    uploadManualCompletion,
    sendEmailNotification,
    rejectSupplierOrder,
    UpdateNewUnitPrice
};

async function saveOrder(data, orderItemArray) {
    let order = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        invoiceDate: data.invoiceDate,
        buyerID: parseInt(data.buyerID),
        dueDate: data.dueDate,
        orderItems: orderItemArray,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }
    const response = await CommonPost('/api/CreateOrder/CreateOrder', null, order);
    return response;
}

async function editOrder(data, orderItemArray) {
    let order = {
        orderID: data.orderID,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        orderNumber: data.orderNumber,
        invoiceDate: data.invoiceDate,
        buyerID: parseInt(data.buyerID),
        dueDate: data.dueDate,
        orderItems: orderItemArray,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }

    const response = await CommonPost('/api/CreateOrder/UpdateOrder', null, order);
    return response;
}


async function getMultiCropsByGroupID(id) {
    var operationEntityArray = [];

    if (id.toString() === '0')
        return operationEntityArray;

    var response = await CommonGet('/api/OperationEntity/GetMultiCropsByGroupID', 'groupID=' + id);

    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }

    return operationEntityArray;
}


async function GetCollectionTypeByOperationEntity(id) {
    var productsArray = [];

    if (id.toString() === '0')
        return productsArray;

    var response = await CommonGet('/api/CollectionType/GetCollectionTypeByOperationEntity', 'id=' + id);

    for (let item of Object.entries(response.data)) {
        productsArray[item[1]["collectionTypeID"]] = item[1]["collectionTypeName"];
    }

    return productsArray;
}

async function GetBuyerByOperationEntity(id) {
    var buyerArray = [];

    if (id === undefined || id.toString() === '0')
        return buyerArray;

    var response = await CommonGet('/api/CreateOrder/GetBuyerByOperationEntity', 'id=' + id);

    return response.data;
}

async function GetAllOrders(id) {
    var response = await CommonGet('/api/CreateOrder/GetAllOrders', 'id=' + id);
    var data = response.data;
    data.forEach(x => {
        x.dueDate = x.dueDate.split('T')[0];
        x.invoiceDate = x.invoiceDate.split('T')[0];
    });
    return data;
}

async function removeOrder(id) {
    var response = await CommonGet('/api/CreateOrder/RemoveOrder', 'id=' + parseInt(id));
    return response;
}

async function getNewOrders(id) {

    if (id === 0) {
        return [];
    }

    var response = await CommonGet('/api/AddSupplier/GetNewOrders', 'id=' + id + '&userID=' + parseInt(tokenDecoder.getUserIDFromToken()));
    var data = response.data;
    data.forEach(x => {
        x.dueDate = x.dueDate.split('T')[0];
        x.invoiceDate = x.invoiceDate.split('T')[0];
    });
    return data;
}

async function getNewOrdersForDropDown(id) {
    var orders = []
    var response = await CommonGet('/api/PurchaseAdvice/GetNewOrders', 'id=' + parseInt(id));
    for (let item of Object.entries(response.data)) {
        orders[item[1]["orderID"]] = item[1]["orderNumber"]
    }
    return orders;
}

async function GetCollectionTypeByOrderID(id) {
    var productsArray = [];

    if (id.toString() === '0')
        return productsArray;

    var response = await CommonGet('/api/AddSuppliers/GetOrderItemsByOrderID', 'id=' + id);

    for (let item of Object.entries(response.data)) {
        productsArray[item[1]["collectionTypeID"]] = item[1]["collectionTypeName"];
    }

    return productsArray;
}

async function GetSuppliersByOperationEntity(id) {
    var supplierArray = [];

    if (id.toString() === '0')
        return supplierArray;

    var response = await CommonGet('/api/AddSupplier/GetSuppliersByOperationEntity', 'id=' + id);
    return response.data;
}

async function SaveSupplierOrder(supplierItems, orderDetails) {

    var supplierOrder = {
        groupID: orderDetails.groupID,
        operationEntityID: orderDetails.operationEntityID,
        orderID: orderDetails.orderID,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        supplierOrderDetails: [
            {
                collectionTypeID: supplierItems.collectionTypeID,
                customerID: supplierItems.customerID,
                orderItemID: supplierItems.orderItemID,
                supplingQauntity: supplierItems.supplingQauntity,
                totalPrice: parseFloat(supplierItems.totalPrice),
                unitPrice: supplierItems.unitPrice,
                state: supplierItems.state,
                supplyDate: supplierItems.supplyDate
            }
        ]
    }
    var response = await CommonPost('/api/AddSupplier/SaveSupplierItems', null, supplierOrder);

    return response;
}

async function getOrdersForSupplierVerify(id) {
    var response = await CommonGet('/api/SupplierVerify/GetOrdersForSupplierVerify', 'id=' + parseInt(id));
    var data = response.data;
    data.forEach(x => {
        x.dueDate = x.dueDate.split('T')[0];
        x.invoiceDate = x.invoiceDate.split('T')[0];
    });
    return data;
}

async function saveApproveStatus(supplierItemsIds) {

    // supplierItemsIds.forEach(x => {
    //     x.modifiedBy = tokenDecoder.getUserIDFromToken()
    // })

    var response = await CommonPost('/api/SupplierVerify/ApproveAllSupplierItem', null, supplierItemsIds);

    return response;
}

async function removeSelectedSupplierOrderItem(supplierorder) {

    var response = await CommonPost('/api/AddSupplier/RemoveSupplierItem', null,
        { supplierOrderItems: supplierorder.supplierOrderItemsID, version: supplierorder.version, modifiedBy: tokenDecoder.getUserIDFromToken() });

    return response;
}

async function CompleteOrder(orderDetails, orderItemsDetails) {
    var model = [];
    orderItemsDetails.forEach(x => {
        model.push({
            orderItemId: x.orderItemID,
            modifiedBy: parseInt(tokenDecoder.getUserIDFromToken())
        });
    })

    var response = await CommonPost('/api/AddSuppliers/SendToReviewOrder', null, model);

    return response;
}

async function GetOrdersForWeighmentVerification(id) {
    var response = await CommonGet('/api/WeighmentVerification/GetOrdersForWeighmentVerify', 'id=' + id + '&userID=' + parseInt(tokenDecoder.getUserIDFromToken()));
    var data = response.data;
    data.forEach(x => {
        x.dueDate = x.dueDate.split('T')[0];
        x.invoiceDate = x.invoiceDate.split('T')[0];
    });
    return data;
}

async function GetSupplierItemDetails(id) {
    var response = await CommonGet('/api/AddSupplier/GetSupplierItemDetailsByID', 'id=' + parseInt(id));
    return response.data;
}

async function OrderConfirm(orderId, itemDetails) {

    var orderItemsArray = [];

    itemDetails.forEach(x => {
        orderItemsArray.push(
            { orderItemID: x.orderItemID, modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()) }
        );
    });

    var response = await CommonPost('/api/WeighmentVerification/ConfirmAllOrderItems', null, orderItemsArray);
    return response;
    return [];
}

async function GetOrdersForCompletion(id) {
    var response = await CommonGet('/api/OrderCompletion/GetOrdersForCompletion', 'id=' + parseInt(id));
    var data = response.data;
    data.forEach(x => {
        x.dueDate = x.dueDate.split('T')[0];
        x.invoiceDate = x.invoiceDate.split('T')[0];
    });
    return data;
}

async function saveOrderCompletionStatus(data,odNo) {

    var model = {
        orderID: data.orderID,
        reason: data.rejectReason,
        groupID:data.groupID,
        operationEntityID:data.operationEntityID,
        orderNo:odNo,
        type: data.rejectReason.length === 0 ? 1 : 2,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken())
    };

    var response = [];

    if (model.type === 1)
        response = await CommonPost('/api/OrderCompletion/OrderCompletion', null, model);
    else
        response = await CommonPost('/api/OrderCompletion/RejectOrder', null, model);

    return response;
}

async function rejectSelectedSupplierOrderItem(rejectReason, supplierorder,datamodel) {

    var model = {
        orderRequestComplexModel:datamodel,
        id: supplierorder.supplierOrderItemsID,
        rejectReason: rejectReason,
        version: supplierorder.version,
        modifiedBy: tokenDecoder.getUserIDFromToken()
    }
    var response = await CommonPost('/api/SupplierVerify/RejectSupplierItem', null, model);

    return response;
}

async function getRemainSupplierCount(id) {
    var response = await CommonPost('/api/AddSupplier/GetRemaingSupplierCount', 'id=' + parseInt(id));

    return response;
}

async function GetImagesForWeighnItem(id) {
    var response = await CommonGet('/api/WeighmentVerification/GetImagesForWeighnItem', 'supplierOrderItemID=' + parseInt(id));
    var result = [];

    response.data.forEach(x => {
        x = 'data:image/jpg;base64, ' + x;
        result.push(x);
    })

    return result;
}

async function GetCollectionTypeByOperationEntityForSearchDropDown(id) {
    var productsArray = [];

    if (id.toString() === '0')
        return productsArray;

    var response = await CommonGet('/api/CollectionType/GetCollectionTypeByOperationEntity', 'id=' + id);
    return response.data;
}

async function getUsers(data) {
    var userArray = [];
    var filterUserModel = {
        groupID: data.groupID === undefined ? 0 : data.groupID.toString(),
        operationEntityID: data.operationEntityID === undefined ? 0 : data.operationEntityID.toString()
    }
    const response = await CommonPost('/api/User/GetPurchaseManagerUsers', null, filterUserModel);

    for (let item of Object.entries(response.data)) {
        userArray[item[1]["aspNetUserId"]] = item[1]["firstName"] + " " + item[1]["lastName"];
    }

    return userArray;

}

async function approveSelectedSupplierOrderItem(supplierorder) {
    var response = await CommonPost('/api/SupplierVerify/ApproveSupplierItem', null, supplierorder);
    // var response = await CommonGet('/api/SupplierVerify/ApproveSupplierItem', 
    //     'supplierOrderItemsID=' + supplierorder.supplierOrderItemsID + '&version=' + supplierorder.version +
    //     '&modifiedBy=' + tokenDecoder.getUserIDFromToken());
    return response;
}

async function OrderItemComplete(model) {
    var modelx = {
        orderItemID: 25,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),


    }
    var response = await CommonPost('/api/WeighmentVerification/OrderItemComplete', null, model);
    return response;
}

async function CheckIsQuantityExceeded(id, quantity) {
    var response = await CommonGet('/api/PurchaseAdvice/CheckIsQuantityExceeded',
        'orderItemID=' + id + '&newQty=' + parseInt(quantity));
    return response.data;
}

async function saveOrderitem(purchaseOrderItem, orderDetails) {

    var model = {
        orderItemID: 0,
        orderID: parseInt(orderDetails.orderID),
        price: parseFloat(purchaseOrderItem.price),
        measuringUnit: parseInt(purchaseOrderItem.measuringUnit),
        collectionTypeID: parseInt(purchaseOrderItem.collectionTypeID),
        itemQuantity: parseFloat(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesStore),
        state: 1,
        packageWeight: parseFloat(purchaseOrderItem.packageWeight),
        totalPackagesStore: parseInt(purchaseOrderItem.totalPackagesStore),
        totalPackagesExport: parseInt(purchaseOrderItem.totalPackagesExport),
        maxAmount: parseFloat(purchaseOrderItem.packageWeight * purchaseOrderItem.totalPackagesExport),
        aspNetUserId: parseInt(purchaseOrderItem.aspNetUserId),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken())
    };

    var response = await CommonPost('/api/OrderCompletion/AddNewOrderItem', null, model);
    return response;
}

async function getOrderDetailsForSupplierAddScreen(id) {

    if (id === 0) {
        return [];
    }

    var model = {
        id: parseInt(id),
        userId: parseInt(tokenDecoder.getUserIDFromToken())
    }

    var response = await CommonPost('/api/AddSupplier/GetOrderDetails', null, model);
    return response.data;
}

async function getOrderDetailsForApproveSupplierScreen(id) {

    if (id === 0) {
        return [];
    }

    var model = {
        id: parseInt(id),
        userId: parseInt(tokenDecoder.getUserIDFromToken())
    }

    var response = await CommonPost('/api/SupplierVerify/GetOrderDetails', null, model);
    return response.data;
}

async function getOrderDetailsForWeighmentVerifyScreen(id) {

    if (id === 0) {
        return [];
    }

    var model = {
        id: parseInt(id),
        userId: parseInt(tokenDecoder.getUserIDFromToken())
    }

    var response = await CommonPost('/api/WeighmentVerification/GetOrderDetails', null, model);
    return response.data;
}

async function getOrderDetailsForOrderCompletionScreen(id) {

    if (id === 0) {
        return [];
    }

    var model = {
        id: parseInt(id),
        userId: parseInt(tokenDecoder.getUserIDFromToken())
    }

    var response = await CommonPost('/api/OrderCompletion/GetOrderDetails', null, model);
    return response.data;
}

async function getSelectedOrderDetails(id) {

    if (id === 0) {
        return [];
    }

    var model = {
        id: parseInt(id),
        userId: parseInt(tokenDecoder.getUserIDFromToken())
    }

    var response = await CommonPost('/api/CreateOrder/GetOrderDetails', null, model);
    return response.data;
}

async function rejectAllSupplierItems(reason, supplierItems) {

    var model = [];

    supplierItems.forEach(x => {
        model.push({
            id: x.supplierOrderItemsID,
            rejectReason: reason,
            version: x.version,
            modifiedBy: tokenDecoder.getUserIDFromToken()
        });
    })

    var response = await CommonPost('/api/SupplierVerify/RejectAllSupplierItem', null, model);
    return response;
}

async function uploadManualCompletion(id) {
    var response = await CommonGet('/api/CreateOrder/UploadSupplierOrdersItems', 'id=' + id);
    return response;
}

async function sendEmailNotification(data) {
    var model = {
        orderNo: data.orderNo,
        buyerName: data.buyerName,
        dueDate: data.dueDate,
        groupID: data.groupID,
        operationEntityID: data.operationEntityID
    };

    var response = await CommonPost('/api/CreateOrder/SendMailForOrderModify', null, model);
    return response;
}

async function rejectSupplierOrder(data) {
    const response = await CommonPost('/api/SupplierVerify/RejectSupplierOrder', null, data);
    return response;
}

async function UpdateNewUnitPrice(newunitprice, supplierID, unitPrice) {
    var model = {
        UnitPrice: parseFloat(newunitprice.unitprice),
        supplierOrderItemsID: parseInt(supplierID),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        previousUnitPrice: parseFloat(unitPrice)
    };
    const response = await CommonPost('/api/CreateOrder/UpdateUnitPrice', null, model);
    return response;
}
